import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd20a5be")

_pushScopeId("data-v-cd20a5be")
const _hoisted_1 = { class: "modalContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_4 = {
  key: 1,
  class: "action-row"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Okay", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: "modal",
    style: { display: _ctx.modelValue ? 'flex' : 'none' }
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createBlock("h1", _hoisted_2, [
            (_ctx.icon)
              ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.icon), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.title), 1 /* TEXT */)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.closeBtn)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              class: "btn close",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', false)))
            }, [
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
})